import React, { useEffect, useState } from "react";
import "./ModalAddContacts.scss";
import PropTypes from "prop-types";
import Modal from "Components/Modal/Modal";
import { connect } from "react-redux";
import { CgClose } from "react-icons/cg";
import { SelectButton } from "primereact/selectbutton";
import { useFetchGetConditional } from "Services/api";
import SearchPeople from "Components/SearchPeople/SearchPeople";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import Loader from "Components/Loader/loader";
import { updateRequests } from "Redux/Actions/requestsActions";

const ModalAddContacts = (props) => {
  const groupsData = useFetchGetConditional(
    "/groups",
    props.auth.token,
    props.requests.groupsData
  );
  const etapesData = useFetchGetConditional(
    "/education_etapes",
    props.auth.token,
    props.requests.etapesData
  );
  const [listContacts, setListContacts] = useState(
    props?.contacts?.length > 0 ? props.contacts : null
  );
  const [value, setValue] = useState(
    props.contacts && props.contacts.length > 0
      ? props.contacts[0].type === "user"
        ? 2
        : props.contacts[0].type === "code"
        ? 3
        : 1
      : 1
  );
  const items = [
    { name: "Groupes", value: 1 },
    { name: "Users", value: 2 },
    { name: "Code Etape", value: 3 },
  ];

  useEffect(() => {
    groupsData.loaded &&
      etapesData.loaded &&
      props.handleRequests({
        groupsData: groupsData.data,
        etapesData: etapesData.data,
      });
  }, [groupsData.loaded, etapesData.loaded]);

  return (
    <Modal
      visible={props.visible}
      setVisible={props.setVisible}
      header="Ajouter des contacts"
      className="modal newsletters addContacts"
      width="90%"
    >
      {groupsData.loaded && etapesData.loaded ? (
        <div className="add__contacts">
          <div className="requetes__input">
            <div className="requetes__start">
              <div className="requetes__start__entete">À : </div>
              <span className="requetes__start__members">
                {listContacts?.map((member, index) => (
                  <span key={index} className="member__fullname">
                    <span className="member__label">{member.label}</span>
                    <CgClose
                      onClick={() => {
                        setListContacts(
                          listContacts.filter((item) => item.id !== member.id)
                        );
                      }}
                    ></CgClose>
                  </span>
                ))}
              </span>
            </div>
          </div>
          <SelectButton
            value={value}
            onChange={(e) => setValue(e.value)}
            optionLabel="name"
            options={items}
          ></SelectButton>
          <div className="add__contacts__bottom">
            {value === 1 &&
              groupsData.loaded &&
              groupsData?.data
                .filter((group) => group.public)
                .map((group, key) => (
                  <div key={key} className="results">
                    <div className="results__label">{group.label}</div>
                    <div
                      className="results__plus pi pi-plus"
                      onClick={() => {
                        let tempArray = listContacts ? [...listContacts] : [];
                        let body = {
                          id: group.id,
                          label: group.label,
                          type: "group",
                        };
                        if (listContacts && listContacts[0]?.type === "group") {
                          if (!tempArray.some((x) => x.id === body.id)) {
                            tempArray.push(body);
                          }
                        } else {
                          tempArray = [body];
                        }
                        setListContacts(tempArray);
                      }}
                    ></div>
                  </div>
                ))}
            {value === 2 && (
              <SearchPeople
                userList={
                  listContacts && listContacts[0].type === "user"
                    ? listContacts
                    : []
                }
                setUserList={(list) => {
                  let newList = list.map((user) => {
                    let newUser = { ...user };
                    if (newUser.firstname) {
                      newUser.label = newUser.firstname + " " + newUser.surname;
                      newUser.type = "user";
                      delete newUser.firstname;
                      delete newUser.surname;
                    }
                    return newUser;
                  });
                  setListContacts(newList);
                }}
              ></SearchPeople>
            )}
            {value === 3 &&
              etapesData.loaded &&
              etapesData?.data.map((etape, key) => (
                <div key={key} className="results">
                  <div className="results__label">{etape.codeEtape}</div>
                  <div
                    className="results__plus pi pi-plus"
                    onClick={() => {
                      let tempArray = listContacts ? [...listContacts] : [];
                      let body = {
                        id: etape.id,
                        label: etape.codeEtape,
                        type: "code",
                      };
                      if (listContacts && listContacts[0]?.type === "code") {
                        if (!tempArray.some((x) => x.id === body.id)) {
                          tempArray.push(body);
                        }
                      } else {
                        tempArray = [body];
                      }
                      setListContacts(tempArray);
                    }}
                  ></div>
                </div>
              ))}
          </div>
          <BtnBleu
            btnTexte="Enregistrer"
            btnAction={() => props.onValid(listContacts)}
          ></BtnBleu>
        </div>
      ) : (
        <Loader></Loader>
      )}
    </Modal>
  );
};

ModalAddContacts.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  onValid: PropTypes.func,
  contacts: PropTypes.object,
  auth: PropTypes.object,
  requests: PropTypes.object,
  handleRequests: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  requests: state.requests,
});
const mapDispatchToProps = (dispatch) => ({
  handleRequests: (value) => {
    dispatch(updateRequests(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalAddContacts);
